// @flow
import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/main/'

// Render the main component into the dom
const rootElement = document.getElementById('app')

if (rootElement != null) {
  // React-Lite and Preact don't offer the hydrate function so far, so we have
  // to fall back on the normal 'render' command
  if (ReactDOM.hydrate !== undefined && rootElement.hasChildNodes()) {
    ReactDOM.hydrate(<App />, rootElement)
  } else {
    ReactDOM.render(<App />, rootElement)
  }
}



// WEBPACK FOOTER //
// ./src/index.js